import { render, staticRenderFns } from "./InitialsAvatar.vue?vue&type=template&id=36678129&scoped=true&"
import script from "./InitialsAvatar.vue?vue&type=script&lang=js&"
export * from "./InitialsAvatar.vue?vue&type=script&lang=js&"
import style0 from "./InitialsAvatar.vue?vue&type=style&index=0&id=36678129&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36678129",
  null
  
)

export default component.exports